// ============================================================
// data/principles.ts — 7 Princípios não-negociáveis do Lume
// ============================================================
// Os 7 pilares éticos do programa. Redação canônica
// alinhada com a Carta de Princípios institucional.
// ============================================================

export interface Principle {
  id: string;
  title: string;
  body: string;
  iconKey: 'eye' | 'brain' | 'lock' | 'scissors' | 'search' | 'scale' | 'a11y';
}

export const principles: ReadonlyArray<Principle> = [
  {
    id: 'subject',
    iconKey: 'eye',
    title: 'A pessoa autista é sujeito do cuidado, não objeto de monitoramento.',
    body:
      'Toda função de coleta é explicável em linguagem acessível ao usuário e desativável conforme decisão clínica e familiar.',
  },
  {
    id: 'instrument',
    iconKey: 'brain',
    title: 'A IA é instrumento clínico, não companhia.',
    body:
      'Jamais se apresenta como humano, jamais como amigo. Não diagnostica e não prescreve — sugere hipóteses ao médico, sempre flagadas como tal.',
  },
  {
    id: 'privacy',
    iconKey: 'lock',
    title: 'Privacidade por padrão.',
    body:
      'Dados brutos — áudio, biometria, ambiente — ficam no dispositivo. Apenas eventos derivados, com finalidade clínica, sobem aos servidores Google.',
  },
  {
    id: 'minimization',
    iconKey: 'scissors',
    title: 'Minimização.',
    body:
      'Se um dado não tem finalidade clínica explícita registrada, ele não é coletado. Cada campo é justificado.',
  },
  {
    id: 'auditability',
    iconKey: 'search',
    title: 'Auditabilidade.',
    body:
      'Toda decisão relevante da IA é rastreável, datada e atribuível. Trilha imutável em /auditLogs com retenção de 5 anos.',
  },
  {
    id: 'compliance',
    iconKey: 'scale',
    title: 'Conformidade não é etapa, é estado.',
    body:
      'LGPD, Resolução CFM 2.314/2022, Lei 14.510/2022 e ANVISA SaMD são pré-requisitos contínuos — não atividades de fim de projeto.',
  },
  {
    id: 'accessibility',
    iconKey: 'a11y',
    title: 'Acessibilidade universal sem ostentação.',
    body:
      'Funciona em equipamento modesto, conexão intermitente, sem instalação obrigatória — proporcional ao público SUS.',
  },
];
